import {
  CheckinInUseError,
  NotFoundError,
  ProjectHasChildrenError,
  ProjectHierarchyError,
  ProjectHierarchyReason,
  ProjectInUseError,
  UndoConflictError,
  ValidationError,
} from '@wiztime/storage';

export const ErrorKey = {
  UndoRemote: 'error.undoRemote',
  NotFound: 'error.notFound',
  ProjectInUse: 'settings.error.projectInUse',
  CheckinInUse: 'settings.error.checkinInUse',
  ProjectHasChildren: 'settings.error.projectHasChildren',
  HierarchyParentMissing: 'settings.error.hierarchy.parentMissing',
  HierarchySelfParent: 'settings.error.hierarchy.selfParent',
  HierarchyParentIsChild: 'settings.error.hierarchy.parentIsChild',
  HierarchyHasChildren: 'settings.error.hierarchy.hasChildren',
  Validation: 'error.validation',
  Unknown: 'error.unknown',
} as const;
export type ErrorKey = (typeof ErrorKey)[keyof typeof ErrorKey];

/** Maps a storage error to the translation key of its user-facing message. */
export function errorKeyOf(error: unknown): ErrorKey {
  if (error instanceof UndoConflictError) return ErrorKey.UndoRemote;
  if (error instanceof NotFoundError) return ErrorKey.NotFound;
  if (error instanceof ProjectInUseError) return ErrorKey.ProjectInUse;
  if (error instanceof CheckinInUseError) return ErrorKey.CheckinInUse;
  if (error instanceof ProjectHasChildrenError) return ErrorKey.ProjectHasChildren;
  if (error instanceof ProjectHierarchyError) {
    switch (error.reason) {
      case ProjectHierarchyReason.ParentMissing:
        return ErrorKey.HierarchyParentMissing;
      case ProjectHierarchyReason.SelfParent:
        return ErrorKey.HierarchySelfParent;
      case ProjectHierarchyReason.ParentIsChild:
        return ErrorKey.HierarchyParentIsChild;
      case ProjectHierarchyReason.HasChildren:
        return ErrorKey.HierarchyHasChildren;
    }
  }
  if (error instanceof ValidationError) return ErrorKey.Validation;
  return ErrorKey.Unknown;
}
